/**
 * @generated SignedSource<<b935127c386c384fdd924817bbaab775>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductTile_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_itemSearch">;
  readonly " $fragmentType": "BuyerProductTile_itemSearch";
};
export type BuyerProductTile_itemSearch$key = {
  readonly " $data"?: BuyerProductTile_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductTile_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "71bee8a0e62244bcf9643cc7791fb9a0";

export default node;
